// Seamless marquee
(function(){
  var track = document.getElementById('mqTrack');
  if (!track) return;
  var firstSet = track.children[0];
  var offset = 0;
  var speed = window.innerWidth >= 768 ? 0.18 : 0.28; // px per frame — slow & subtle

  function step() {
    offset -= speed;
    // When we've scrolled past the entire first set, reset seamlessly
    if (Math.abs(offset) >= firstSet.offsetWidth) {
      offset += firstSet.offsetWidth;
    }
    track.style.transform = 'translateX(' + offset + 'px)';
    requestAnimationFrame(step);
  }

  // Wait for images to load so widths are correct
  window.addEventListener('load', function() { requestAnimationFrame(step); });
  // Start early with approximate values
  requestAnimationFrame(step);
})();
